export default __webpack_public_path__ + "static/media/25120404.19c08b3f.jpg";